import { ComponentChildren, h } from 'preact';
import styled from 'styled-components';

interface BoxInterface {
	mt?: number;
	mb?: number;
	ml?: number;
	mr?: number;
	align?: 'center' | 'left' | 'right';
	children: ComponentChildren;
}

const BoxStyled = styled.div<Partial<BoxInterface>>`
	${({ mt }) => mt && `margin-top: ${mt}px;`}
	${({ mb }) => mb && `margin-bottom: ${mb}px;`}
	${({ ml }) => ml && `margin-left: ${ml}px;`}
	${({ mr }) => mr && `margin-right: ${mr}px;`}
	${({ align }) => align && `text-align: ${align};`}
`;

export const Box = ({ mt, mb, ml, mr, align, children }: BoxInterface) => (
	<BoxStyled as="div" mt={mt} mb={mb} ml={ml} mr={mr} align={align}>
		{children}
	</BoxStyled>
);
